import { Helmet } from 'react-helmet-async';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://letter-quest.com';

/**
 * Per-page SEO meta tags for better indexing and AI findability.
 * Set REACT_APP_SITE_URL in .env for your production domain.
 */
export default function SeoHead({ title, description, path = '' }) {
  const fullTitle = title ? `${title} | Letter Quest` : 'Letter Quest – Free Word Games';
  const url = `${SITE_URL.replace(/\/$/, '')}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
